import { IconFilter, IconFilterFilled } from '@tabler/icons-react';

type SearchControlsProps = {
  showFilters: boolean;
  activeFilters: string[];
  setShowFilters: (show: boolean) => void;
  closeModal: () => void;
};

export function SearchControls({ showFilters, activeFilters, setShowFilters, closeModal }: SearchControlsProps) {
  return (
    <div className="flex items-center justify-between border-t border-[#dee2e6] px-4 py-2 text-xs text-gray-500 dark:border-[#424242] dark:text-gray-400">
      <div
        className={`flex cursor-pointer items-center gap-2 ${(showFilters || activeFilters.length > 0) && 'text-blue-500'}`}
        onClick={() => setShowFilters(!showFilters)}
      >
        <div className="text-xs">Filter</div>
        <div className="rounded-md bg-gray-100 p-1 dark:bg-[#424242]">
          {showFilters || activeFilters.length > 0 ?
            <IconFilterFilled size={10} />
          : <IconFilter size={10} />}
        </div>
      </div>
      <div
        className="flex cursor-pointer items-center gap-2"
        onClick={closeModal}
      >
        <div>Close</div>
        <kbd className="rounded-md bg-gray-100 p-1 text-[0.66rem] leading-none dark:bg-[#424242]">ESC</kbd>
      </div>
    </div>
  );
}
